import { useState, useEffect } from "react";
import { reviewsService } from "../services/reviewsService";

export const useRatedManagers = () => {
  const [ratedManagers, setRatedManagers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastKey, setLastKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchRatedManagers = async (isInitial = false) => {
    try {
      setIsLoading(true);
      setError(null);

      const currentLastKey = isInitial ? null : lastKey;
      const response = await reviewsService.getUserRatedManagers(
        currentLastKey
      );

      if (isInitial) {
        setRatedManagers(response.reviews || []);
      } else {
        setRatedManagers((prev) => [...prev, ...(response.reviews || [])]);
      }

      setLastKey(response.last_key || null);
      setHasMore(!!response.last_key);
    } catch (err) {
      setError(err.message || "Failed to fetch rated managers");
      console.error("Error fetching rated managers:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    if (!isLoading && hasMore && lastKey) {
      fetchRatedManagers(false);
    }
  };

  const refresh = () => {
    setRatedManagers([]);
    setLastKey(null);
    setHasMore(true);
    fetchRatedManagers(true);
  };

  useEffect(() => {
    fetchRatedManagers(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ratedManagers,
    isLoading,
    error,
    hasMore,
    loadMore,
    refresh,
  };
};
